const NAMESPACE = "attachmentsUtil";

const KEYS = {
    viewButtonLabel: "viewButtonLabel",
    downloadButtonLabel: "downloadButtonLabel",
    removeButtonLabel: "removeButtonLabel",
    yesButtonLabel: "yesButtonLabel",
    noButtonLabel: "noButtonLabel",
    confirmRemovalMessageLabel: "confirmRemovalMessageLabel"
};

const MESSAGES = {
    [KEYS.viewButtonLabel]: {
        value: "Review",
        comment: "Text for button to open attachment review page"
    },
    [KEYS.downloadButtonLabel]: {
        value: "Download",
        comment: "Text for download button"
    },
    [KEYS.removeButtonLabel]: {
        value: "Remove",
        comment: "Text for remove button"
    },
    [KEYS.yesButtonLabel]: {
        value: "Yes",
        comment: "Text for yes button"
    },
    [KEYS.noButtonLabel]: {
        value: "No",
        comment: "Text for no button"
    },
    [KEYS.confirmRemovalMessageLabel]: {
        value: 'Are you sure you want to remove "{fileName}"?',
        comment: "Text to confirm attachment removal"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
